module.exports = __webpack_public_path__ + "static/media/YB5M14_3.59956272.jpg";